import Table from '@/common/components/Table';
import React from 'react';
import { HEADERS } from './constants/headers';
import { getRaws } from './helpers/getRaws';

const CompanyTable = ({ companies, setCompany }) => {
	return (
		<Table
			className='styled-table'
			headers={HEADERS}
			raws={getRaws(companies, setCompany)}
		/>
	);
};

export default CompanyTable;
